@if (eventBooking$ | async; as eventBooking){
    <app-event-headline [event]="eventBooking.event"/>
    <div class="flex gap-10">
        <div class="w-1/4">
            <h1>Your Tickets</h1>
            <app-ticket-pill [includePrice]="true" [primaryTicket]="getPrimaryTicket(eventBooking)" [additionalTickets]="getEventTickets(eventBooking)"/>
            @if ((eventBooking.event.organiser?.partnerFee ?? 0) > 0){
                <div class="text-end text-xs">
                    LRP Tickets Service Charge: {{ eventBooking.event.organiser?.partnerFee | currency:'GBP'}}
                </div>
            }
            @if (!eventBooking.paid){
                <hr class="my-2">
                <div class="text-end font-semibold">Total Due: {{ getTotalCost(eventBooking) | currency:'GBP'}}</div>
            }
        </div>
        <div class="w-3/4 ">
            <h1>Booking Information</h1>
            <table class="mb-3">
                <tr>
                    <td class="font-semibold">Booking Name:</td>
                    <td class="ps-3">{{ eventBooking.firstName }} {{ eventBooking.surname }}</td>
                </tr>
                <tr>
                    <td class="font-semibold">Booking Made:</td>
                    <td class="ps-3">{{ eventBooking.bookingMade | date}}</td>
                </tr>
            </table>
            <h1>Payment Information</h1>
            @if (eventBooking.paid){
                @if (payment$ | async; as payment){
                    <table class="mb-3">
                        <tr class="mb-3">
                            <td class="font-semibold">Total Paid:</td>
                            <td class="ps-3" [class.line-through]="payment.value === 0" >{{ payment.value | currency:'GBP'}}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">Payment Made:</td>
                            <td class="ps-3">{{ payment.date | date }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">Payment Method:</td>
                            <td class="ps-3">{{ payment.paymentProvider.name }}</td>
                        </tr>
                        @if (payment.paymentProvider){
                            <tr>
                                <td class="font-semibold">{{ payment.paymentProvider.name }} Payment ID:</td>
                                <td class="ps-3">{{  getPaymentDataID(payment.paymentData)?.value }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">{{ payment.paymentProvider.name }} Order ID:</td>
                                <td class="ps-3">{{  getPaymentDataOrder(payment.paymentData)?.value }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">{{ payment.paymentProvider.name }} Reference ID:</td>
                                <td class="ps-3">{{  getPaymentDataReference(payment.paymentData)?.value }}</td>
                            </tr>
                        }
                    </table>
                }
            }
            @else if (eventBooking.totalDue > 0) {
                <app-paypal [eventBooking]="eventBooking"/>
            }
        </div>
    </div>
}